module.exports = __webpack_public_path__ + "img/GreatFloodCH.bd50dfc4.jpg";